import { useTheme } from './ThemeProvider';
import { useFeatureEnabled } from '../hooks/usePublicConfig';

interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle = ({ className = '' }: ThemeToggleProps) => {
  // Runtime visibility gate (features.dark_mode) — the FOUC script and preset
  // dark CSS stay build-time; this only hides the button (PRP-10 D8).
  const featureOn = useFeatureEnabled('darkMode');
  const { resolvedTheme, setMode, darkModeAvailable } = useTheme();
  if (!darkModeAvailable || !featureOn) return null;
  const isDark = resolvedTheme === 'dark';
  return (
    <button
      type="button"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      data-testid="theme-toggle"
      onClick={() => setMode(isDark ? 'light' : 'dark')}
      className={`w-9 h-9 rounded-lg flex items-center justify-center transition-colors hover:bg-primary/10 ${className}`}
    >
      {isDark ? (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round"
            d="M12 3v2m0 14v2M5.6 5.6l1.4 1.4m9.9 9.9l1.4 1.4M3 12h2m14 0h2M5.6 18.4l1.4-1.4m9.9-9.9l1.4-1.4M12 8a4 4 0 100 8 4 4 0 000-8z" />
        </svg>
      ) : (
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round"
            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      )}
    </button>
  );
};
